<template>
  <vue-d3 :onExportPng="handleExportPng" :showExport="showExport">
    <div ref="vis-ref"></div>
  </vue-d3>
</template>

<script>
import { PieBarLabeled } from './PieBar';
import VueD3 from '../VueD3.vue';

export default {
  name: 'PieBarWrapper',
  components: {
    VueD3,
  },
  props: {
    exportTitle: String,
    exportFileName: String,
    showExport: {
      type: Boolean,
      default: false,
    },
    series: {
      type: Array,
      required: true,
    },
    width: Number,
    height: Number,
    barHeight: Number,
    labelFontSize: Number,
    valueFormatter: Function,
    valueAccessor: Function,
  },
  data() {
    return {
      pieBarInstance: null,
    };
  },
  mounted() {
    this.pieBarInstance = new PieBarLabeled({
      target: this.$refs['vis-ref'],
      exportFileName: this.exportFileName,
      exportTitle: this.exportTitle,
      series: this.series,
      width: this.width,
      height: this.height,
      barHeight: this.barHeight,
      labelFontSize: this.labelFontSize,
      valueFormatter: this.valueFormatter,
      valueAccessor: this.valueAccessor,
    });
    this.$emit('init', this.pieBarInstance);
  },
  watch: {
    series(newValue, oldValue) {
      if (this.pieBarInstance) {
        this.pieBarInstance.updateData(newValue);
      }
    },
  },
  methods: {
    handleExportPng() {
      if (this.pieBarInstance) {
        this.pieBarInstance.exportToPng();
      }
    },
  },
};
</script>
